import { api } from "api/api";
import { USER_ROLE } from "contexts/auth/auth.context";
import { FormValues } from "hooks/login/useLogin.hook";
import { ShowWeekendsOption } from "helpers/calendar-weekends.helper";

export interface InfoDemo {
    visible: boolean;
    message: string;
}

export interface CalendarConfig {
    start: string;
    end: string;
    step: number;
    showWeekends: ShowWeekendsOption;
    allowTimeLock: boolean;
    backgroundColorScheme?: string;
}

export interface LoginData {
    token?: string;
    role?: USER_ROLE;
    hasAdminRights?: boolean;
    showReserveListOnCalendar?: boolean;
    appointmentTypeManagementIsAllowed?: boolean;
    showPartnerSection?: boolean;
    showProductsSection?: boolean;
    showAddressFieldsOnNewClientForm?: boolean;
    showAppointmentSchemaSection?: boolean;
    showPatientSchemaSection?: boolean;
    isClientMobileAppUsed?: boolean;
    showPatientOrigin?: boolean;
    calendar?: CalendarConfig;
    infoDemo?: InfoDemo;
    isZenPilates?: boolean;
    booksyModule?: boolean;
    isChatTurnedOff?: boolean;
    isTestUser?: boolean;
    isVerified?: boolean;
    isAllowedAppointmentWithoutClientOrService?: boolean;
    showCommissionStats?: boolean;
    eventsDaysBackLimit?: number | null;
}

export interface LoginResponse {
    returnCode: number;
    data: {
        token: string;
        role: USER_ROLE;
        hasAdminRights: boolean;
        showReserveListOnCalendar: boolean;
        appointmentTypeManagementIsAllowed: boolean;
        showPartnerSection: boolean;
        showProductsSection: boolean;
        showAddressFieldsOnNewClientForm: boolean;
        showAppointmentSchemaSection: boolean;
        showPatientSchemaSection: boolean;
        isClientMobileAppUsed: boolean;
        showPatientOrigin?: boolean;
        config: {
            calendar: CalendarConfig;
        };
        infoDEMO: InfoDemo;
        isZenPilates: boolean;
        booksyModule?: boolean;
        isChatTurnedOff?: boolean;
        isTestUser?: boolean;
        isVerified?: boolean;
        isAllowedAppointmentWithoutClientOrService?: boolean;
        showCommissionStats?: boolean;
        eventsDaysBackLimit?: number | null;
    };
}

export function mapLoginResponseData(d: LoginResponse["data"]): LoginData {
    return {
        token: d.token,
        role: d.role,
        hasAdminRights: d.hasAdminRights,
        showReserveListOnCalendar: d.showReserveListOnCalendar,
        appointmentTypeManagementIsAllowed: d.appointmentTypeManagementIsAllowed,
        showPartnerSection: d.showPartnerSection,
        showProductsSection: d.showProductsSection,
        showAddressFieldsOnNewClientForm: d.showAddressFieldsOnNewClientForm,
        showAppointmentSchemaSection: d.showAppointmentSchemaSection,
        showPatientSchemaSection: d.showPatientSchemaSection,
        isClientMobileAppUsed: d.isClientMobileAppUsed,
        showPatientOrigin: d.showPatientOrigin,
        calendar: d.config.calendar,
        infoDemo: d.infoDEMO,
        isZenPilates: d.isZenPilates,
        booksyModule: d.booksyModule,
        isChatTurnedOff: d.isChatTurnedOff,
        isTestUser: d.isTestUser,
        isVerified: d.isVerified,
        isAllowedAppointmentWithoutClientOrService: d.isAllowedAppointmentWithoutClientOrService,
        showCommissionStats: d.showCommissionStats,
        eventsDaysBackLimit: d.eventsDaysBackLimit,
    };
}

export default async function login(params: FormValues): Promise<LoginData> {
    const url = "api/mobile/auth/login";

    const response = await api.post<LoginResponse>(url, {
        login: params.login,
        password: params.password,
    });

    return mapLoginResponseData(response.data.data);
}
